import React from 'react'
import { Image } from 'antd'

import img1 from '../../../../shared/assets/IMG_1691.jpeg'
import img2 from '../../../../shared/assets/IMG_1704.jpeg'
import img3 from '../../../../shared/assets/IMG_1705_1.jpeg'
import { useTranslation } from 'react-i18next'

const images = [img1, img2, img3]

const GallerySection: React.FC = () => {
    const { t } = useTranslation()

    return (
        <section
            style={{
                padding: '20px 20px',
                backgroundColor: '#f4f2e8',
                textAlign: 'center'
            }}
        >
            <h2 style={{ fontSize: '2rem' }}>{t('gallery.title')}</h2>
            <Image.PreviewGroup>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '20px',
                        flexWrap: 'wrap',
                        marginTop: '20px'
                    }}
                >
                    {images.map((src, index) => (
                        <Image
                            key={index}
                            src={src}
                            alt={`Gallery ${index + 1}`}
                            width={300}
                            style={{ borderRadius: '10px' }}
                        />
                    ))}
                </div>
            </Image.PreviewGroup>
        </section>
    )
}

export default GallerySection
